import React from 'react'

const PrimaryButton = ({ text }) => {
    return (
        <div className='bg-[#6DA5C0] duration-500 text-[#294D61] px-4 md:px-8 py-2 cursor-pointer rounded-lg flex justify-center items-center text-sm md:text-md font-bold'>{text}</div>
    )
}

export default PrimaryButton